import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#000000]" data-id="element-804">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-805">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-806">
          <div className="md:col-span-2" data-id="element-807">
            <Link to="/" className="inline-block mb-4" data-id="element-808">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-809" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-810">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-811">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-812">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-813">
              <li data-id="element-814">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-815">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-816">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-817">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-818">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-819">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-820">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-821">
              <li className="flex justify-between" data-id="element-822">
                <span data-id="element-823">{t('footer.monFri')}</span>
                <span data-id="element-824">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-825">
                <span data-id="element-826">{t('footer.saturday')}</span>
                <span data-id="element-827">6:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-828">
                <span data-id="element-829">{t('footer.sunday')}</span>
                <span data-id="element-830">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-831">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-832">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-833">
              <li data-id="element-834">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-835">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-836">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-837">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-838">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-839">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-840">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-841">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-842">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-843">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-844">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-845">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-846">
          <p data-id="element-847">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-848">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-849">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-850">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-851">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#2F2828]" data-id="element-852">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide" data-id="element-853">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[500] text-[#17A347]" data-id="element-854">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-855">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-856">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-857">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}